import { locations } from "@/data/locations";

// LocalBusiness (RoofingContractor) structured data for the homepage.
//
// Kodiak is a service-area business: it publishes a phone, hours and a service
// area, but no street address anywhere on the site and none is recorded in the
// portal. So this deliberately omits streetAddress and addressLocality rather
// than inventing them, and leans on areaServed instead. Only facts already
// published on the site are asserted here.
//
// This lives in its own module because the homepage ROUTE consumes it. Importing
// a value out of a page module into its route creates an import cycle that
// breaks the server bundle at init — see src/data/careers.ts for the same note.

const SITE_URL = "https://kodiakse.com";

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "RoofingContractor",
  "@id": `${SITE_URL}/#business`,
  name: "Kodiak Structures & Exteriors",
  url: SITE_URL,
  telephone: "+1-651-983-1609",
  email: "info@kodiakse.com",
  description:
    "Kodiak Structures & Exteriors delivers expert roofing, siding, windows, and gutter services built to withstand the toughest conditions. Serving homeowners throughout Minnesota.",
  image: `${SITE_URL}/og-image.png`,
  logo: `${SITE_URL}/og-image.png`,
  address: {
    "@type": "PostalAddress",
    addressRegion: "MN",
    addressCountry: "US",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:00",
      closes: "18:00",
    },
  ],
  areaServed: locations.map((location) => ({
    "@type": "City",
    name: location.name,
    addressRegion: location.city.split(", ")[1] ?? "MN",
  })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Roofing & Exterior Services",
    itemListElement: [
      { name: "Roof Replacement", path: "/services/roof-replacement" },
      { name: "Roof Repair", path: "/services/roof-repair" },
      { name: "Storm Damage Restoration", path: "/services/storm-damage" },
      { name: "Siding Installation", path: "/services/siding" },
      { name: "Window Replacement", path: "/services/windows" },
      { name: "Gutter Installation", path: "/services/gutters" },
    ].map((service) => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: service.name,
        url: `${SITE_URL}${service.path}`,
      },
    })),
  },
};
